import { RECIPIENT_EIN_TOOLTIP, RECIPIENT_SSN_TOOLTIP } from "../../web/businesslogic/components/addrecipientnew/constant";
import { RECIPIENT_ID_TYPE, RECIPIENT_TYPES_1042_S_TITLES, RECIPIENT_TYPE_1042_S, RECIPIENT_TYPE_TITLE } from "../../web/businesslogic/components/addrecipientnew/getrecipienttype/constants";
import Payer from "./Payer";

export default class Recipient {

    static getPayeeType(recipientType, is1042SForm = false) {
        if (is1042SForm) {
            return RECIPIENT_TYPE_1042_S.find(r => r.title === recipientType)?.value;
        } else {
            return recipientType === RECIPIENT_TYPE_TITLE.INDIVIDUAL ? "SSN" : "EIN";
        }
    }

    static getTINProps(recipientType, tinValue, requestType, tinNotProvided) {

        switch (recipientType) {
            case RECIPIENT_TYPE_TITLE.INDIVIDUAL:
                return {
                    tinTooltip: RECIPIENT_SSN_TOOLTIP,
                    tinPlaceholder: 'XXX - XX - XXXX',
                    tinValue: Payer.convertToSSN(tinValue),
                    tinRules: requestType || tinNotProvided ? { required: false } : { regex: { pattern: /^\d{3}-\d{2}-\d{4}$/, message: "Please enter a valid SSN" }, required: true },
                    showNames: true,
                    tinDisabled: false,
                }

            case RECIPIENT_TYPE_TITLE.BUSINESS:
                return {
                    tinTooltip: RECIPIENT_EIN_TOOLTIP,
                    tinPlaceholder: "XX - XXXXXXX",
                    tinValue: Payer.convertToEIN(tinValue),
                    tinRules: requestType || tinNotProvided ? { required: false } : { regex: { pattern: /^\d{2}-\d{7}$/, message: "Please enter a valid EIN" }, required: true },
                    showNames: false,
                    tinDisabled: false,
                }

            case RECIPIENT_TYPES_1042_S_TITLES.SSN_ITIN:
                return {
                    tinTooltip: RECIPIENT_SSN_TOOLTIP,
                    tinPlaceholder: 'XXX - XX - XXXX',
                    tinValue: Payer.convertToSSN(tinValue),
                    tinRules: { regex: { pattern: /^\d{3}-\d{2}-\d{4}$/, message: "Please enter a valid SSN" }, required: true },
                    showNames: true,
                    tinDisabled: false,
                }

            case RECIPIENT_TYPES_1042_S_TITLES.NO_US_TIN_INDIVIDUAL:
                return {
                    tinTooltip: RECIPIENT_SSN_TOOLTIP,
                    tinPlaceholder: 'XXX - XX - XXXX',
                    tinValue: "",
                    tinRules: { required: false },
                    showNames: true,
                    tinDisabled: true,
                    
                }

            case RECIPIENT_TYPES_1042_S_TITLES.EIN:
                return {
                    tinTooltip: RECIPIENT_EIN_TOOLTIP,
                    tinPlaceholder: "XX - XXXXXXX",
                    tinValue: Payer.convertToEIN(tinValue),
                    tinRules: { regex: { pattern: /^\d{2}-\d{7}$/, message: "Please enter a valid EIN" }, required: true },
                    showNames: false,
                    tinDisabled: false,
                }

            case RECIPIENT_TYPES_1042_S_TITLES.QI_WP_WT_EIN:
                return {
                    tinTooltip: RECIPIENT_EIN_TOOLTIP,
                    tinPlaceholder: "XX - XXXXXXX",
                    tinValue: Payer.convertToEIN(tinValue),
                    tinRules: { regex: { pattern: /^\d{2}-\d{7}$/, message: "Please enter a valid EIN" }, required: true },
                    showNames: false,
                    tinDisabled: false,
                }

            case RECIPIENT_TYPES_1042_S_TITLES.TIN_REQUIRED_BUT_NOT_PROVIDED:
            case RECIPIENT_TYPES_1042_S_TITLES.TIN_APPLIED_FOR:
            case RECIPIENT_TYPES_1042_S_TITLES.NO_US_TIN_BUSINESS:
                return {
                    tinTooltip: RECIPIENT_EIN_TOOLTIP,
                    tinPlaceholder: "XX - XXXXXXX",
                    tinValue: "",
                    tinRules: { required: false },
                    showNames: false,
                    tinDisabled: true
                }

            default:
                return {
                    tinTooltip: RECIPIENT_SSN_TOOLTIP,
                    tinPlaceholder: 'XXX - XX - XXXX',
                    tinValue: Payer.convertToSSN(tinValue),
                    tinRules: { required: false,  regex: { pattern: /^\d{3}-\d{2}-\d{4}$/, message: "Please enter a valid SSN" }},
                    showNames: true,
                    tinDisabled: false,
                }
        }
    }

    static getRecipientType(idType) {
        switch (idType) {
            case RECIPIENT_ID_TYPE.EIN:
                return RECIPIENT_TYPE_TITLE.BUSINESS;

            case RECIPIENT_ID_TYPE.SSN:
                return RECIPIENT_TYPE_TITLE.INDIVIDUAL;

            default:
                return RECIPIENT_TYPE_TITLE.INDIVIDUAL;
        }

    }

    static getPayeeFileType(RecipientType) {
        if(RecipientType === RECIPIENT_TYPE_TITLE.INDIVIDUAL || RecipientType === RECIPIENT_TYPE_TITLE.BUSINESS){
            return RecipientType;
        } else {
            return "";
        }
    }
}